<template>
  <div>    
    <h1>Normalizing</h1>
    <p v-if="done">
      Finished!
    </p>
  </div>
</template>

<script>
  import config from '@/config'
  import axios from 'axios';
  import axiosRetry from 'axios-retry';

  axiosRetry(axios, { retries: 3 });

export default {
  created () {
    this.initialize()
  },
  data: () => ({
    done: false,
  }),
  methods: {
    initialize() {
      var url = `${config.CLOUDDRIVE_API_ENDPOINT}normalize`
      axios.get(url)
        .then(response => {
          console.log("DONE!")
          this.done = true
        }).catch((err) => {
          console.log(err)
        })
    },

  }
}
</script>
